import {SleepAsync} from "js-vextensions";
import {Button, CheckBox, Text, TextArea} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {Observer, RunInAction, RunInAction_Set} from "web-vcore";
import React, {useMemo} from "react";
import {store} from "../../../../Store/index.js";
import {nativeBridge} from "../../../../Utils/Bridge/Bridge_Native.js";
import {TranscribeTarget, VibrationStrength} from "../../../../Server/DB/engineConfigs/@EngineConfig/@EC_DreamTranscribe.js";
import {useAutoUnregisterWhisperTranscriptionWatcher, WhisperTranscriptionWatcher} from "../../../../Utils/Bridge/Whisper.js";
import {GetLiveLocalSession, liveSession} from "../../../../Engine/LiveSessionManagement.js";
import {DreamTranscribeComp} from "../../../../Engine/LiveSession/Components/DreamTranscribeComp.js";
import {AdvancedTranscriptionHandler} from "../../../../Engine/LiveSession/Components/AdvancedTranscriptionHandler.js";
import {WaitXThenRun} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import {GetSelectedEngineConfig} from "../../../../Server/DB/engineConfigs.js";

export const TranscribePanel_Header = observer_mgl(()=>{
	const self = useMemo(()=>{
		const uiState = store.main.engine.journey.transcribe;
		const advancedTranscriptionHandler = new AdvancedTranscriptionHandler({
			getTranscribeTarget: ()=>TranscribeTarget.panel,
			getConfig: ()=>{
				const dreamTranscribeConfig = GetSelectedEngineConfig()?.dreamTranscribe;
				// start with basic, workable config
				const config = {
					markTimeEveryXMinutes: 5,
					timestamps_liteMarkersInBetween: true,
					bracketWordsNearTTS: -999, // never bracket words near TTS
					bracketWordsNearTTS_noSpeakCountOrVibrate: false, // irrelevant (bracketing disabled)
					bracketWordsNearTTS_noDJ: false, // irrelevant (bracketing disabled)
					onTranscribe_speakWordCount: false,
					onTranscribe_vibrateDuration: .03,
					onTranscribe_vibrateStrength: "light" as VibrationStrength,
				};
				// but use the selected engine-config's values, for any set there
				for (const key of Object.keys(config)) {
					if (dreamTranscribeConfig != null && dreamTranscribeConfig[key] != null) {
						config[key] = dreamTranscribeConfig[key];
					}
				}

				// apply "Vibrate" checkbox as an "override", if vibrate-duration value is incompatible
				if (config.onTranscribe_vibrateDuration == 0 && uiState.vibrateOnTranscribeChunk) {
					config.onTranscribe_vibrateDuration = .03;
				} else if (config.onTranscribe_vibrateDuration != 0 && !uiState.vibrateOnTranscribeChunk) {
					config.onTranscribe_vibrateDuration = 0;
				}

				return config;
			},
		});
		return {
			advancedTranscriptionHandler,
			whisperTranscriptionWatcher: new WhisperTranscriptionWatcher({
				processingPriority: 10,
				absorbsResult: true,
				keepsRecordingAlive: true,
				onChunkTranscribed: info=>{
					advancedTranscriptionHandler.HandleChunk(info);
				},
			}),
		};
	}, []);
	const uiState = store.main.engine.journey.transcribe;

	useAutoUnregisterWhisperTranscriptionWatcher(self.whisperTranscriptionWatcher);

	const recording = self.whisperTranscriptionWatcher.IsRegistered();
	return (
		<>
			<CheckBox text="Vibrate" title="Note: Uses vibration settings of dream-transcribe comp of active session, if set there." value={uiState.vibrateOnTranscribeChunk} onChange={val=>RunInAction_Set(()=>uiState.vibrateOnTranscribeChunk = val)}/>
			<Button ml={5} iconSize={24} style={{flex: null, width: 40, height: 40}}
				mdIcon={recording ? "stop" : "record"} title={recording ? "Stop recording" : "Start recording"}
				onClick={async()=>{
					const newTranscribing = !self.whisperTranscriptionWatcher.IsRegistered();
					if (newTranscribing) {
						self.whisperTranscriptionWatcher.Register();
					} else {
						self.whisperTranscriptionWatcher.UnregisterAfterTranscribedToNow();
					}
				}}/>
		</>
	);
});

export function GetTranscribePanelHeightOverride() {
	const uiState = store.main.engine.journey.transcribe;
	if (liveSession?.Comp(DreamTranscribeComp).GetCurrentTranscriptionTarget() == TranscribeTarget.dreamSegment && !uiState.forceShowTranscribeText) return 50;
	return null;
}

export const TranscribePanel = observer_mgl(()=>{
	const uiState = store.main.engine.journey.transcribe;

	const transcribeToSegment = liveSession?.Comp(DreamTranscribeComp).GetCurrentTranscriptionTarget() == TranscribeTarget.dreamSegment;
	return <>
		{transcribeToSegment &&
		<Text style={{textAlign: "center"}} onClick={()=>RunInAction_Set(()=>uiState.forceShowTranscribeText = !uiState.forceShowTranscribeText)}>
			Transcribing is being redirected to the last-ended dream-segment. (click to show/hide panel anyway)
		</Text>}
		{(!transcribeToSegment || uiState.forceShowTranscribeText) &&
		<TextArea style={{flex: 1}} value={uiState.transcribeText} onChange={val=>RunInAction_Set(()=>uiState.transcribeText = val)}/>}
	</>;
});